import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, Signal, ViewChild, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatNativeDateModule } from '@angular/material/core';
import { MatCalendar, MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

@Component({
  selector: 'app-button-datepicker',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatCardModule,
    MatDatepickerModule,
    MatIconModule,
    MatMenuModule,
    MatNativeDateModule,
    OverlayModule
  ],
  templateUrl: './button-datepicker.component.html',
  styleUrl: './button-datepicker.component.scss'
})
export class ButtonDatepickerComponent implements OnInit {
  
  @ViewChild('calendar') calendar!: MatCalendar<Date>;

  @Input() set initialDate(value: Date) {
    if (value && value !== this.date()) {
      this.updateDate(value);
    }
  }
  @Input() title: string;
  
  @Output() dateChange = new EventEmitter<Date>();

  date: Signal<Date> = signal(new Date());
  isViewMenuOpen = signal(false);

  ngOnInit(): void {}
  
  incrementDay(): void {
    const newDate = new Date(this.date().setDate(this.date().getDate() + 1));
    this.updateDate(newDate);
  }

  decrementDay(): void {
    const newDate = new Date(this.date().setDate(this.date().getDate() - 1));
    this.updateDate(newDate);
  }

  onDateChange(event: Date | null): void {
    if (event) {
      this.updateDate(event);
      if (this.isViewMenuOpen()) {
        this.calendarVisibility(false);
      }
    }
  }

  calendarVisibility(isVisible: boolean): void {
    this.isViewMenuOpen.set(isVisible);
  }

  private updateDate(newDate: Date): void {
    (this.date as any).set(newDate);
    this.dateChange.emit(newDate);
  }
}
